import { requestFromServer } from "./api-client";

const Dates = {
  listAvailableDates: async (
    idPlant,
    idProduct,
    idLoadType,
    clientDocumentNumber,
    transporterCNPJ
  ) => {
    return requestFromServer(
      `v1/Time_Blocks/listAvailableDates/${idPlant}/${idProduct}/${idLoadType}?cnpj=${clientDocumentNumber}${transporterCNPJ ? `&transporter_cnpj=${transporterCNPJ}` : ''}`
    );
  },
};

export default Dates;
